import {Box} from '@material-ui/core'
import {DataGrid, GridColDef, GridRowsProp} from '@material-ui/data-grid'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'src/redux/rootReducer'
import {Root} from './styled'
import {EditButton} from './styled'
import _ from 'lodash'
import User from 'src/models/User'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {RouteComponentProps} from 'react-router'
import {actions as usersActions} from 'src/redux/modules/users'
import ManagementTemplate from 'src/components/ManagementTemplate'

const UsersPage: React.FC<RouteComponentProps> = ({history}: RouteComponentProps) => {
  const {users, dataState} = useSelector((state: RootState) => state.users)

  const dispatch = useDispatch()

  ///
  /// Called when someone clicks on "create user" - we want to navigate to that page
  ///
  const onCreateUserClick = () => {
    history.push('/users/create')
  }

  // Define the columns.
  const columns: GridColDef[] = [
    {field: 'email', headerName: 'E-Mail', align: 'center', headerAlign: 'center', width: 200},
    {field: 'name', headerName: 'Full Name', align: 'center', headerAlign: 'center', width: 200},
    {
      field: 'isAdmin',
      headerName: 'Admin Access?',
      align: 'center',
      headerAlign: 'center',
      width: 200,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" justifyContent="center" width="100%">
            {params.value && <CheckCircleIcon />}
          </Box>
        )
      },
    },
    {
      field: 'isEmployee',
      headerName: 'React-PT?',
      align: 'center',
      headerAlign: 'center',
      width: 200,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" justifyContent="center" width="100%">
            {params.value && <CheckCircleIcon />}
          </Box>
        )
      },
    },
    {
      field: 'editControl',
      headerName: ' ',
      align: 'center',
      headerAlign: 'center',
      width: 100,
      renderCell: (params) => (
        <EditButton
          color={'secondary'}
          onClick={() => {
            history.push(`/users/${params.id}`)
          }}>
          Edit
        </EditButton>
      ),
    },
  ]

  // Now the rows (the action data)
  const values = _.values(users) as User[]
  const rows: GridRowsProp = values.map(({id, email, name, isAdmin, isEmployee}) => ({
    id,
    email,
    name,
    isAdmin,
    isEmployee,
  }))

  // Was there an error?
  const errorMessage = dataState.error ? dataState.error.message : undefined

  if (dataState.state === 'unloaded' && !errorMessage) {
    // Load up the users!
    dispatch(usersActions.getAllUsers())
  }

  return (
    <Root>
      <ManagementTemplate
        title="User Management"
        busy={dataState.state === 'loading'}
        error={dataState.error}
        createButtonTitle="Create User"
        onCreateClick={() => onCreateUserClick()}>
        <DataGrid
          disableSelectionOnClick
          rowHeight={100}
          autoHeight
          rows={rows}
          columns={columns}
        />
      </ManagementTemplate>
    </Root>
  )
}

export default UsersPage
